import { render, staticRenderFns } from "./Nueva-venta-desde-on.vue?vue&type=template&id=af35b87a"
import script from "./Nueva-venta-desde-on.vue?vue&type=script&lang=js"
export * from "./Nueva-venta-desde-on.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports